import {
    SHOW_MODAL,
    HIDE_MODAL
} from './constants';

import createReducer from '../../utils/createReducer';

const initialState = [];

export const showModal = (state, payload) => {
    const {modalType, modalProps} = payload;

    // Always pushing a new modal onto the stack
    return [...state, {modalType, modalProps}];
}

export const hideModal = (state, payload) => {
    // Always popping the last modal off the stack
    return state.filter((value) => value !== state[state.length - 1]);
}

export default createReducer(initialState,  {
    [SHOW_MODAL] : showModal,
    [HIDE_MODAL] : hideModal
});